// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_SnapshotResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for snapshot endpoint
 *
 * Returns snapshot data with contas array, totais, and fechamento metadata.
 *
 * `contas` reuses Fechamentos_PlanoContaSnapshotRow — same shape, same source
 * (Plano_contas_snapshots_model::getContasComTotais → getByFechamentoWithEfetivo
 *  + 4 variance enrichments injected in PHP).
 * `totais` reuses Fechamentos_PlanoContaTotaisRow — same shape, same source
 * (Plano_contas_snapshots_model::getTotals).
 */
import type { Fechamentos_PlanoContaSnapshotRow } from './Fechamentos_PlanoContaSnapshotRow'
import type { Fechamentos_PlanoContaTotaisRow } from './Fechamentos_PlanoContaTotaisRow'
import type { Planoscontas_SnapshotFechamentoRow } from './Planoscontas_SnapshotFechamentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_SnapshotResponseDados {
contas: Fechamentos_PlanoContaSnapshotRow[]
totais: Fechamentos_PlanoContaTotaisRow
fechamento: Planoscontas_SnapshotFechamentoRow
}

export type Planoscontas_SnapshotResponse = ApiResponse<Planoscontas_SnapshotResponseDados>;

registerResponseContract('Planoscontas_SnapshotResponse', {
  contas: {
    type: 'array',
    required: true,
    items: {
      id:                      { type: 'number',  required: false },
      fechamento_id:           { type: 'number',  required: false },
      categoria_id:            { type: 'number',  required: false },
      nome_conta_snapshot:     { type: 'string',  required: false },
      tipo_snapshot:           { type: 'string',  required: false },
      percentual_snapshot:     { type: 'string',  required: false },
      valor_previsto_snapshot: { type: 'string',  required: false },
      created_at:              { type: 'string',  required: false },
      valor_efetivo:           { type: 'string',  required: false },
      variacao_percentual:     { type: 'number',  required: false },
      variacao_valor:          { type: 'number',  required: false },
      variance_status:         { type: 'string',  required: false },
      variance_icon:           { type: 'string',  required: false },
    },
  },
  totais: {
    type: 'object',
    required: true,
    fields: {
      total_previsto:      { type: 'number',  required: true },
      total_efetivo:       { type: 'number',  required: true },
      variacao_percentual: { type: 'number',  required: false },
      num_contas:          { type: 'number',  required: true },
    },
  },
  fechamento: {
    type: 'object',
    required: true,
    fields: {
      id:      { type: 'number',  required: true },
      periodo: { type: 'string',  required: false },
      status:  { type: 'string',  required: false },
    },
  },
})
